import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
// import Index from '../views/index'
// import Index from '@/views/index'

// 公共路由
export const constantRoutes = [
  
  {
    path: '/',
    component: () => import('@/views/index/index'),
    hidden: true,
  },
  {
    path: '/wangqi', //往期回顾
    title:'往期回顾',
    component: () => import('@/views/index/wangqi'),
    hidden: true,
  },
  {
    path: '/weibo', //政务微博
    title:'政务微博',
    component: () => import('@/views/index/weibo'),
    hidden: true,
  },
  {
    path: '/videoDetail', //政务微博
    title:'详情',
    component: () => import('@/views/index/videoDetail'),
    hidden: true,
  },
  {
    path: '/weixin', //政务微信
    title:'政务微信',
    component: () => import('@/views/index/weixin'),
    hidden: true,
  }
  
  
]
// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js